import React from 'react';
import { PASSWORD_RULES } from '../../utils/passwordRules';

/**
 * PasswordChecklist — lista en vivo de requisitos de contraseña, con ✓/○
 * según se vayan cumpliendo mientras el usuario escribe.
 *
 * Props:
 *   password {string} — valor actual del input de contraseña
 *   color    {string} — color de texto base (se ajusta al tema activo)
 */
export default function PasswordChecklist({ password, color = '#fff' }) {
  return (
    <ul style={{
      listStyle: 'none',
      margin: '6px 0 0',
      padding: 0,
      fontSize: 10.5,
      display: 'flex',
      flexWrap: 'wrap',
      gap: '4px 12px', // fila 4px, columna 12px — reglas fluyen en 1-2 líneas según ancho
    }}>
      {PASSWORD_RULES.map(rule => {
        const ok = rule.test(password || '');
        return (
          <li
            key={rule.key}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 5,
              color: ok ? '#4caf50' : `${color}99`,
              transition: 'color 0.2s',
              whiteSpace: 'nowrap',
            }}
          >
            <span style={{ width: 12, textAlign: 'center' }}>{ok ? '✓' : '○'}</span>
            {rule.label}
          </li>
        );
      })}
    </ul>
  );
}
